/**
 * Created by tmorone on 2/8/2016.
 */

var Backbone = require('backbone');
var moment = require('moment');

/**
 * A model for each row of the leaderboard.
 * The time property is created on initialization with the display value based on created_at.
 */
var LeaderboardFeat = Backbone.Model.extend( {
    initialize: function(item) {
        this.set('time', moment(item.created_at).calendar(null, {sameDay: '[Today at] LTS', lastDay: '[Yesterday at] LTS', sameElse: 'LLL'}));
    }
});

/**
 * Pulls from the 'collectionFeats' api and stores the result as a collection of LeaderboardFeat objects.
 * Must be initialized with a collection id.
 */
module.exports = Backbone.Collection.extend({
    model: LeaderboardFeat,
    url: function() {
        return '/api/collectionFeats/' + this.id;
    },

    initialize: function(models, options) {
        this.id = options.id;
    }
});